// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
    margin-right: 5px;
}

select {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px;
    outline: none;
    /* appearance: none; */
    /* background: white url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23333333"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 10px center; */
    background-size: 16px 16px;
}

select:focus {
    border-color: dodgerblue;
    box-shadow: 0 0 5px rgba(30, 144, 255, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/components/editing/WidgetsEditor.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2LAA2L;IAC3L,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,2CAA2C;AAC/C","sourcesContent":["label {\n    margin-right: 5px;\n}\n\nselect {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 2px;\n    outline: none;\n    /* appearance: none; */\n    /* background: white url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"%23333333\"><path d=\"M7 10l5 5 5-5z\"/></svg>') no-repeat right 10px center; */\n    background-size: 16px 16px;\n}\n\nselect:focus {\n    border-color: dodgerblue;\n    box-shadow: 0 0 5px rgba(30, 144, 255, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
